import { FunctionComponent } from 'react';

type LegendsIconProps = {
  width?: number | string;
  height?: number | string;
  active?: boolean;
  disable?: boolean;
};

const LegendsIcon: FunctionComponent<LegendsIconProps> = ({
  width = 34,
  height = 34,
  active = false,
  disable = false,
}) => {
  const circleFill = active ? '#561BDC' : disable ? '#D5D5D5' : '#FAFAFA';
  const strokeColor = active ? '#EDEDED' : disable ? '#8E8E8E' : '#1A1A1A';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 34"
    >
      <g transform="translate(-870 -1160)">
        <circle
          cx="17"
          cy="17"
          r="17"
          transform="translate(870 1160)"
          fill={circleFill}
        />
        <g transform="translate(11328 552.25)">
          <g
            transform="translate(-10450 617)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          >
            <circle cx="2" cy="2" r="2" stroke="none" />
            <circle cx="2" cy="2" r="1.4" fill="none" />
          </g>
          <g
            transform="translate(-10450 623)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          >
            <rect width="4" height="4" rx="0.6" stroke="none" />
            <rect x="0.6" y="0.6" width="2.8" height="2.8" fill="none" />
          </g>
          <path
            d="M1.74.456a.3.3,0,0,1,.521,0l1.483,2.6a.3.3,0,0,1-.26.449H.517a.3.3,0,0,1-.26-.449Z"
            transform="translate(-10450 629)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
          <line
            x2="11"
            transform="translate(-10443 619)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeWidth="1.2"
          />
          <line
            x2="11"
            transform="translate(-10443 625)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeWidth="1.2"
          />
          <line
            x2="11"
            transform="translate(-10443 631)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeWidth="1.2"
          />
        </g>
      </g>
    </svg>
  );
};

export default LegendsIcon;
